export default function hasWriteAccess(user, districtid, cityid) {
  const district = districtid !== '-' ? parseInt(districtid, 10) : districtid;
  const city = districtid !== '-' ? parseInt(cityid, 10) : districtid;
  return user.control || user.steering.includes(district) || user.coaching.includes(city);
}
